import { ajax } from '@/api/ajax';

// 国家信息记录接口
export interface CountryRecord {
  /**
   * 国家编码
   */
  countryCode: string;
  /**
   * 国家名称
   */
  countryName: string;
  /**
   * 国家图标
   */
  countryIcon: string;
  /**
   * 语言列表
   */
  langList: LangRecord[];
}

// 语言信息记录接口
export interface LangRecord {
  /**
   * 语言编码
   */
  langCode: string;
  /**
   * 语言名称
   */
  langName: string;
}

// 接口返回值接口
export interface CountryLangQueryResponse {
  /**
   * 国家列表
   */
  countryList: CountryRecord[];
}

// 接口请求函数
export function countryLangQueryUsingPost() {
  return ajax<CountryLangQueryResponse>({
    url: '/api/tis/web/base/countryLang/list',
    method: 'post',
    data: {}
  });
}
